import React, { useState, useEffect } from "react";
import imgCompany from "../../../assets/Foto/ic_perusahaan.jpg";
import imgBSI from "../../../assets/Foto/ic_bsi_trust_mark.jpg";
import imgISO9001 from "../../../assets/Foto/ic_iso_9001.png";
import AboutUsComponents from "../../components/aboutUsComponents/AboutUsComponents";
import { AboutUsModel } from "../../../domain/entities/AboutUsModel";
import { fetchAboutUs } from "../../../domain/usecases/fetchAboutUs";
import "react-multi-carousel/lib/styles.css";
import SpinnerLoading from "../../components/spinnerLoading/SpinnerLoading";

const CompanyPage: React.FC = () => {

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [aboutUs, setAboutUs] = useState<AboutUsModel[]>([]);

    // Fetch about us
    useEffect(() => {
        const fetchingAboutUs = async () => {
            try {
                const aboutUss = await fetchAboutUs();
                
                // Extract and set both desktop and mobile banners
                const aboutUsItem = aboutUss.map((item) => item);
                
                setAboutUs(aboutUsItem);
            } catch (err) {
                console.error("Failed to fetch about us:", err);
                setError("Failed to load about us. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        fetchingAboutUs();
    }, []);

    // Handle loading state
    if (loading) {
        return <SpinnerLoading />;
    }

    // Handle error state
    if (error) {
        return <div className="text-center text-red-500">{error}</div>;
    }

    return (
        <div className="flex flex-col">
            <img src={imgCompany} className="w-full h-1/2 md:h-1/2 mt-2" alt="ic-company" />
            {aboutUs.map( (item) => (
                <AboutUsComponents aboutUs={item} />
            ))}
            
            <div className="flex flex-row items-center justify-center mt-4 mb-12 md:mt-4 md:mb-16 gap-4">
                <img src={imgISO9001} className="w-44 h-14 md:w-52 md:h-16" alt="ic-iso" />
                <img src={imgBSI} className="w-28 h-14 md:w-32 md:h-16" alt="ic-bsi" />
            </div>
        </div>
    );
};

export default CompanyPage;